"use strict";
window.theme = window.theme || {}
theme.quickNewsletterForm = function() {

    function quickNewsletterForm() {

        this.btn = {
            follow_newsletter: document.querySelectorAll('.follow__us__btn__newsletter'),
            close: document.querySelectorAll('.quick-newsletter-form__close'),
            successClose: document.querySelectorAll('.newsletter-close'),
            overlay: document.querySelectorAll('.quick-newsletter-form__overlay')
        }
        this.container = {
            quick_drawer: document.querySelector('.quick-newsletter-form'),
            country_list: document.querySelector('[name="contact[country]"]'),
            confirmation: document.querySelector('.quick-newsletter-form-submit-status'),
            body: document.querySelector('body'),
            success_wrap: document.querySelector('.success-wrap'),
            newsletter_text: document.querySelector('.newsletter__text'),
            newsletter_form_inner: document.querySelector('.newsletter-form-inner')
        }

        this.load();

    }
    quickNewsletterForm.prototype._trapFocus = function(e) {
        if (e.key === 'Escape') { this.closedrawer(); return; }
        if (e.key !== 'Tab') return;

        var container = this.container.quick_drawer.querySelector('.quick-newsletter-form__container');
        var focusable = Array.from(container.querySelectorAll(
            'button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),a[href],[tabindex]:not([tabindex="-1"])'
        )).filter(function(el) {
            var node = el;
            while (node && node !== container) {
                if (window.getComputedStyle(node).display === 'none') return false;
                node = node.parentElement;
            }
            return true;
        });

        if (!focusable.length) return;

        var currentIndex = focusable.indexOf(document.activeElement);
        e.preventDefault();

        if (e.shiftKey) {
            focusable[currentIndex <= 0 ? focusable.length - 1 : currentIndex - 1].focus();
        } else {
            focusable[currentIndex >= focusable.length - 1 ? 0 : currentIndex + 1].focus();
        }
    };

    quickNewsletterForm.prototype.load = function() {
        var _ = this;
        _._boundTrapFocus = _._trapFocus.bind(_);
        _.btn.follow_newsletter.forEach(element => {
            element.addEventListener('click', () => {
                _._lastFocus = element;
                _.opendrawer();
            })
        })
        _.btn.close.forEach(element => {
            element.addEventListener('click', () => {
                _.closedrawer();
                if(document.URL.endsWith("#nl-sign-up") ){
                  window.history.replaceState(null,null," ")
                }
            })
        })
        _.btn.successClose.forEach(element => {
          element.addEventListener('click', () => {
              _.closedrawer();
          })
        })
        _.btn.overlay.forEach(element => {
            element.addEventListener('click', () => {
                _.closedrawer();
                if(document.URL.endsWith("#nl-sign-up") ){
                  window.history.replaceState(null,null," ")
                }
            })
        })
        if(_.container.country_list.length>0) {
          _.repopulatecountry();
        }
        if(_.container.confirmation.value === 'false' && _.getdrawerstatus('quickNewsletterForm') === 'close') {
            _.container.quick_drawer.classList.remove('success');
            _.closedrawer();
        }
        if(_.container.confirmation.value === 'true' && _.getdrawerstatus('quickNewsletterForm') === 'open') {
            _.container.quick_drawer.classList.add('success');
            _.opendrawer();
        }
    }

    quickNewsletterForm.prototype.opendrawer = function() {
        var _ = this;
        _.container.quick_drawer.classList.add('active');
        _.container.quick_drawer.classList.add('visible');

        _.container.success_wrap.style.display = "none";
        _.container.newsletter_text.style.display = "block";
        _.container.newsletter_form_inner.style.display = "flex";
        _.container.body.style.top = `-${window.scrollY}px`;
        _.container.body.style.width = '100%';
        _.container.body.style.position = 'fixed';
        document.addEventListener("DOMContentLoaded", () => {
          setTimeout( () => {
            document.body.style.setProperty('padding-right', '6px');
          }, 1000);
        });
        _.setdrawerstatus('open');

        var container = _.container.quick_drawer.querySelector('.quick-newsletter-form__container');
        var firstFocusable = container.querySelector(
            'button:not([disabled]),input:not([disabled]),select:not([disabled]),a[href],[tabindex]:not([tabindex="-1"])'
        );
        if (firstFocusable) firstFocusable.focus();
        document.addEventListener('keydown', _._boundTrapFocus);
    }

    quickNewsletterForm.prototype.closedrawer = function() {
        var _ = this;
        _.container.quick_drawer.classList.remove('active');
        _.container.quick_drawer.classList.remove('visible');

        const scrollY = document.body.style.top;
        document.body.style.width = '';
        document.body.style.position = '';
        document.body.style.top = '';
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
        _.setdrawerstatus('close');
        _.container.quick_drawer.classList.remove('success');

        document.removeEventListener('keydown', _._boundTrapFocus);
        if (_._lastFocus) { _._lastFocus.focus(); _._lastFocus = null; }

        if(_.container.confirmation.value === 'true') {
            window.location = window.location.pathname;
        }
    }

    quickNewsletterForm.prototype.repopulatecountry = function() {
        var _ = this;
        if(_.container.country_list.getAttribute('data-location') == null) {
          return false;
        };
        fetch(_.container.country_list.getAttribute('data-location'), {
        method: 'GET'
        })
        .then(response => {
        return response.json();
        })
        .then(data => {
            if(data.length>0) {
                data.forEach((country) => {
                let newOption = new Option(country.name, country.name);
                _.container.country_list.add(newOption,undefined);
                })
                _.container.country_list.selectedIndex = 0;
               }
        })
        .catch((error) => {
        });
    }
    quickNewsletterForm.prototype.setdrawerstatus = function(cvalue) {
        const d = new Date();
        d.setTime(d.getTime() + (1 * 24 * 60 * 60 * 1000));
        let expires = "expires="+d.toUTCString();
        document.cookie = 'quickNewsletterForm' + "=" + cvalue + ";" + expires + ";path=/";
    }
    quickNewsletterForm.prototype.getdrawerstatus = function(cname) {
        let name = cname + "=";
        let ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "close";
    }

  theme.quickNewsletterForm = new quickNewsletterForm;

}

theme.quickNewsletterForm();

$(function(){
    var ur = window.location.href;
      var newsletter_form_url = 'https://myhub.remy-cointreau.com/apiproxies-shopify-webhook-uat/CRM-NewsLetter?SHOPIFY_PARAM=Newsletter-LXIII-US&AUTHORIZATION=Z7HsSHkvaYZyH1PujmEfVuUEI9GutbhuCx6iwQawZntxijlB'
      if(ur.includes('https://us.louisxiii-cognac.com/')) {
        newsletter_form_url = 'https://myhub.remy-cointreau.com/apiproxies-shopify-webhook-prod/CRM-NewsLetter?SHOPIFY_PARAM=Newsletter-LXIII-US&AUTHORIZATION=4ZzUoSdlRBmDk7qahhVtePwI2kjbODYQlFB7TA1ZGs2B9t27'
      }
    $(".newsletter-close").on("click",function(){
      $(".popup-newsletter").removeClass("visible");
    })

    var dropdown = $('.newsLetterFormCountryDropdown');
    dropdown.empty();

  // Populate dropdown with list of provinces
    fetch('https://cdn.shopify.com/s/files/1/0633/7488/5093/files/country_list_en.json?v=1709630686')
    .then(response => response.json())
    .then(countries => {
        // Get geolocation
        fetch("/browsing_context_suggestions.json")
        .then(result => result.json())
        .then((data) => {
            const currentCountry = data.detected_values.country_name;
            const getRegExp = new RegExp(currentCountry)
            if(currentCountry.includes("United States")){
                repopulateStates()
                repopulateStatesPopup()
            }
            else{
                $('#newsletter-state').parent().css('display', 'none');
                $('#newsletter-state-popup').parent().css('display', 'none');
            }

            $.each(countries, function (key, entry) {
                if ( getRegExp.test(entry.name) ) {
                    dropdown.append($('<option></option>').attr({
                    'value': entry.name,
                    'selected': 'selected'
                    }).text(entry.name));
                } 
                else {
                    if(entry.name == "China (Mainland)"){
                        dropdown.append($('<option></option>').attr('value', "China").text(entry.name));
                    } else{
                        dropdown.append($('<option></option>').attr('value', entry.name).text(entry.name));
                    }
                }
            })      
        })
        .catch((error) => {
            console.error('Error:', error);
        });
    })
    .catch((error) => {
        console.error('Error:', error);
    });

    repopulateStates();
    dropdown.on('change', function () {
      repopulateStates();
    });

    repopulateStatesPopup();
    dropdown.on('change', function () {
      repopulateStatesPopup();
    });
    

    $(".input_field select").each(function(){
        if($(this).val() != ""){
            $(this).addClass("on");
        }
    });
    $(".input_field select").focusin(function(e) {
        $(this).addClass("on");
    }).focusout(function(e) {
        if( $(this).val() == "" ){
            $(this).removeClass("on");
        }else {
            $(this).removeClass("error");
            $(this).parent(".input_field").find(".error-message").remove();
        }
    });

    $(".input_field input").each(function(){
      if($(this).val() != ""){
        $(this).addClass("on");
      }
    });
    $(".input_field input").change(function(e) {
      $(this).addClass("on");
    })
    $(".input_field input").focusin(function(e) {
        $(this).addClass("on");
      }).focusout(function(e) {
        if( $(this).val() == "" ){
          $(this).removeClass("on");
        }else {
          $(this).removeClass("error");
          $(this).parent(".input_field").find(".error-message").remove();
          if($(this).is("#newsletter-email")){
            if( !IsEmail($("#newsletter-email").val()) ){
              $(this).addClass("error");
              $(this).parent(".input_field").append("<span class='error-message'>Please, enter your email address, e.g., louissmith@gmail.com</span>");
            }
          }
        }
    });

    $("#NewsletterFormAcceptsMarketing").on('change', function () {
        if ($(this).is(':checked')) {
          $(this).attr('value', 'true');
          if($(this).hasClass("error")){
            $(this).removeClass("error");
            $(this).parents(".checkbox_field").find(".error-message").remove();
          }
        } else {
          $(this).attr('value', 'false');
          if(!$(this).hasClass("error")){
            $(this).addClass("error");
            $(this).parents(".checkbox_field").append("<span class='error-message'>Please, check the agree to be contacted by email.</span>");
          }
        }
    });
    $("#NewsletterFormAcceptsMarketingPhone").on('change', function () {
      if ($(this).is(':checked')) {
        $(this).attr('value', 'true');
        if($(this).hasClass("error")){
          $(this).removeClass("error");
          $(this).parents(".checkbox_field").find(".error-message").remove();
        }
      } else {
        $(this).attr('value', 'false');
        if(!$(this).hasClass("error")){
          $(this).addClass("error");
          $(this).parents(".checkbox_field").append("<span class='error-message'>Please, check the agree to be contacted by phone.</span>");
        }
      }
    });

    $(".newsletter-form__button").click(function(e){
        e.preventDefault();
        var pass = true;
        if( $("#newsletter-last_name").val() == "" ){
            pass = false;
          if( !$("#newsletter-last_name").hasClass("error")){
            $("#newsletter-last_name").addClass("error");
            $("#newsletter-last_name").parent(".input_field").append("<span class='error-message'>Please, enter your last name (Smith)</span>");
          }
        }
        if( $("#newsletter-first_name").val() == "" ){
            pass = false;
          if( !$("#newsletter-first_name").hasClass("error")){
            $("#newsletter-first_name").addClass("error");
            $("#newsletter-first_name").parent(".input_field").append("<span class='error-message'>Please, enter your first name (Louis)</span>");
          }
        }
        if( $("#newsletter-email").val() == "" ){
            pass = false;
          if( !$("#newsletter-email").hasClass("error")){
            $("#newsletter-email").addClass("error");
            $("#newsletter-email").parent(".input_field").append("<span class='error-message'>Please, enter your email address, e.g., louissmith@gmail.com</span>");
          }
        }else if( !IsEmail($("#newsletter-email").val()) ){
            pass = false;
          if( !$("#newsletter-email").hasClass("error")){
            $("#newsletter-email").addClass("error");
            $("#newsletter-email").parent(".input_field").append("<span class='error-message'>Please, enter a valid email address, e.g., louissmith@gmail.com</span>");
          }
        }

        if ( $('#newsletter-country').val() === "United States of America" || $('#newsletter-country').val() === "China" || $('#newsletter-country').val() === "Canada")
        {
          if ( !$('#newsletter-state').val() || $('#newsletter-state').val() === "") {
            pass = false;
            if( !$("#newsletter-state").hasClass("error")){
                $("#newsletter-state").addClass("error");
                $("#newsletter-state").parent(".input_field").append("<span class='error-message'>Please, select the state.</span>");
            }
          }
        }

        if(pass) {
            $(".newsletter-form-submit form").submit();
        }
      });
    
      $(".newsletter-popup-form__button").click(function(e){
        e.preventDefault();
        var pass = true;
        if( $("#newsletter-last_name-popup").val() == "" ){
            pass = false;
          if( !$("#newsletter-last_name-popup").hasClass("error")){
            $("#newsletter-last_name-popup").addClass("error");
            $("#newsletter-last_name-popup").parent(".input_field").append("<span class='error-message'>Please, enter your last name (Smith)</span>");
          }
        }
        if( $("#newsletter-first_name-popup").val() == "" ){
            pass = false;
          if( !$("#newsletter-first_name-popup").hasClass("error")){
            $("#newsletter-first_name-popup").addClass("error");
            $("#newsletter-first_name-popup").parent(".input_field").append("<span class='error-message'>Please, enter your first name (Louis)</span>");
          }
        }
        if( $("#newsletter-email-popup").val() == "" ){
            pass = false;
          if( !$("#newsletter-email-popup").hasClass("error")){
            $("#newsletter-email-popup").addClass("error");
            $("#newsletter-email-popup").parent(".input_field").append("<span class='error-message'>Please, enter your email address, e.g., louissmith@gmail.com</span>");
          }
        }else if( !IsEmail($("#newsletter-email-popup").val()) ){
            pass = false;
          if( !$("#newsletter-email-popup").hasClass("error")){
            $("#newsletter-email-popup").addClass("error");
            $("#newsletter-email-popup").parent(".input_field").append("<span class='error-message'>Please, enter a valid email address, e.g., louissmith@gmail.com</span>");
          }
        }
        if(pass) {
            $(".popup-form-submit form").submit();
        }
      });

    function IsEmail(email) {
        var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        if(!regex.test(email)) {
            return false;
        }else{
            return true;
        }
    }

    function repopulateStates() {
      var selectedCountry = document.getElementById('newsletter-country').value ? document.getElementById('newsletter-country').value : "United States of America";;
      var stateDropdown = document.getElementById('newsletter-state');
      
      stateDropdown.innerHTML = '';
      stateDropdown.disabled = true;
      var defaultOption = document.createElement('option');
      defaultOption.selected = true;
      if (selectedCountry === "United States of America" || selectedCountry === "China" || selectedCountry === "Canada") {
        stateDropdown.parentElement.style.display = 'block';
        if(selectedCountry === "United States of America") {
          stateDropdown.setAttribute("name","province")
        }else if(selectedCountry === "China"){
          stateDropdown.setAttribute("name","province_cn")
        }else if(selectedCountry === "Canada"){
          stateDropdown.setAttribute("name","province_cnd")
        }
  
        fetch(stateDropdown.getAttribute('data-state-url'))
          .then(response => response.json())
          .then(data => {
              var defaultOption = document.createElement('option');
              defaultOption.disabled = true;
              defaultOption.value = '';
              defaultOption.selected = true;
              defaultOption.text = '';
              stateDropdown.appendChild(defaultOption);
              stateDropdown.disabled = false;
              if (data.countries.length <= 0) {
                  return;
              }
              data.countries.forEach(countrystate => {
                  if (countrystate.country === selectedCountry) {
                      countrystate.states.forEach(state => {
                          var option = document.createElement('option');
                          option.value = state;
                          option.text = state;
                          stateDropdown.appendChild(option);
                      })
                  }
              })
        })
      
      }
      else {
        stateDropdown.setAttribute("name","");
        stateDropdown.parentElement.style.display = 'none';
        return;
      }
  
    }

    function repopulateStatesPopup() {
      var selectedCountry = document.getElementById('newsletter-country-popup').value ? document.getElementById('newsletter-country-popup').value : "United States of America";
      var stateDropdown = document.getElementById('newsletter-state-popup');
      stateDropdown.innerHTML = '';
      stateDropdown.disabled = true;
      var defaultOption = document.createElement('option');
      defaultOption.selected = true;
      // var selectedCountry = $('#newsletter-country-popup').val() ? $('#newsletter-country-popup').val() : "United States of America";
      // var stateDropdown = $('#newsletter-state-popup');
      // stateDropdown.empty();

      if (selectedCountry === "United States of America" || selectedCountry === "China"|| selectedCountry === "Canada") {
        stateDropdown.parentElement.style.display = 'block';
        if(selectedCountry === "United States of America") {
          stateDropdown.setAttribute("name","province")
          
        }else if(selectedCountry === "China"){
          stateDropdown.setAttribute("name","province_cn")
          
        }else if(selectedCountry === "Canada"){
          stateDropdown.setAttribute("name","province_cnd")
          
        }
  
        fetch(stateDropdown.getAttribute('data-state-url'))
          .then(response => response.json())
          .then(data => {
              var defaultOption = document.createElement('option');
              defaultOption.disabled = true;
              defaultOption.value = '';
              defaultOption.selected = true;
              defaultOption.text = '';
              stateDropdown.appendChild(defaultOption);
              stateDropdown.disabled = false;
              if (data.countries.length <= 0) {
                  return;
              }
              data.countries.forEach(countrystate => {
                  if (countrystate.country === selectedCountry) {
                      countrystate.states.forEach(state => {
                          var option = document.createElement('option');
                          option.value = state;
                          option.text = state;
                          stateDropdown.appendChild(option);
                      })
                  }
              })
        })
      
      }
      else {
        stateDropdown.setAttribute("name","");
        stateDropdown.parentElement.style.display = 'none';
        return;
      }

      // if (selectedCountry !== "United States of America") {
      //     stateDropdown.attr('disabled', true).append($('<option></option>').attr({
      //         'id': 'default-state',
      //         'value': "-",
      //         'selected': 'selected'
      //     }).text("-"));
      //     stateDropdown.addClass("on");
      //     if( !stateDropdown.hasClass("error")){
      //         stateDropdown.removeClass("error");
      //         stateDropdown.parent(".input_field").find(".error-message").remove();
      //     }
      //     return;
      // }

      // $.getJSON(stateDropdown.attr("data-state-url"), function (data) {
      //     stateDropdown.attr('disabled', false).append($('<option></option>').attr({
      //         'disabled': true,
      //         'value': "",
      //         'selected': 'selected'
      //     }).text(""));
      //     stateDropdown.removeClass("on");
      //     if (data.countries.length <= 0) {
      //         return;
      //     }
      //     data.countries.forEach(countrystate => {
      //         if (countrystate.country === selectedCountry) {
      //             countrystate.states.forEach(state => {
      //                 stateDropdown.append($('<option></option>').attr('value', state).text(state));
      //             })
      //         }
      //     })
      //   }
      // )
  }


  const myForm = $('form#newsletter_form')[0]
  $(".newsletter-form-submit form").on('submit',  async (event) => {

      event.preventDefault();
      const first_name = $('#newsletter-first_name').val();
      const last_name = $('#newsletter-last_name').val();
      const email = $('#newsletter-email').val();
      const province = $('#newsletter-state').val();
      const country = $('#newsletter-country').val();
      const rm_optin = $('#NewsletterFormAcceptsMarketing').val();
      const phone_optin = $('#NewsletterFormAcceptsMarketingPhone').val();
      const rm_program = $('#NewsletterFormProgram').val();
      const data_privacy = $('#data_privacy').val();
      const sub_data_source = $('#sub_data_source').val();
      const provinceSelect = document.querySelector('#newsletter-state');
      const provinceName = provinceSelect.getAttribute('name');
      const provinceValue = provinceSelect.value;

      const data = {
        first_name,
        last_name,
        email,
        country,
        phone_optin,
        rm_program,
        rm_optin,
        data_privacy: data_privacy === "true",
        sub_data_source,
        ...(provinceName === 'province'
        ? { province: provinceValue }
        : provinceName === 'province_cn'
        ? { province_cn: provinceValue }
        : provinceName === 'province_cnd'
        ? { province_cnd: provinceValue }
        : {})
      }
      data.accepts_marketing = true
      const url = newsletter_form_url;

        // Spinner
        $('.cfp_sub span').addClass('d-none')
        $('.cfp_sub .spinner').removeClass('d-none')

          // Pass the data to Boomi
         fetch(url, {
              method: 'post',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(data)
            })
           .then(function (response) {
             if (response.ok) {
               // If form submitted will remove the spinner and close the form
               $('.cfp_sub span').removeClass('d-none')
               $('.cfp_sub .spinner').addClass('d-none')
               myForm.reset();
               $('#NewsletterFormAcceptsMarketingPhone').attr("value",'false');
               //$('#NewsletterFormAcceptsMarketing').attr("value",'false');
               dataLayer.push({
                'event': 'newsletter_subscription'
               });
               let date = new Date();
               date.setFullYear(date.getFullYear() + 1); // ajoute 1 an
               document.cookie = "newsletter_subscribed=true; expires=" + date.toUTCString() + "; path=/";
             }

             // Examine the text in the response
             response.json().then(function (data) {
               $(".newsletter__text,.newsletter-form-inner, .required-fields-explanation").fadeOut(600,function(){
                $(".success-wrap").fadeIn();
                repopulateStates()
                repopulateStatesPopup()
               })
             });
           });

  })

  $(".popup-form-submit form").on('submit',  async (event) => {
    event.preventDefault();
    const first_name = $('#newsletter-first_name-popup').val();
    const last_name = $('#newsletter-last_name-popup').val();
    const email = $('#newsletter-email-popup').val();
    const province = $('#newsletter-state-popup').val();
    const country = $('#newsletter-country-popup').val();
    const rm_optin = $('#NewsletterFormAcceptsMarketing-popup').val();
    const phone_optin = $('#NewsletterFormAcceptsMarketingPhone').val();
    const rm_program = $('#NewsletterFormProgram-popup').val();
    const data_privacy = $('#data_privacy-popup').val();
    const sub_data_source = $('#sub_data_source-popup').val();
    const provinceSelect = document.querySelector('#newsletter-state-popup');
    const provinceName = provinceSelect.getAttribute('name');
    const provinceValue = provinceSelect.value;

    const data = {
      first_name,
      last_name,
      email,
      country,
      phone_optin,
      rm_program,
      rm_optin,
      data_privacy: data_privacy === "true",
      sub_data_source,
      ...(provinceName === 'province'
      ? { province: provinceValue }
      : provinceName === 'province_cn'
      ? { province_cn: provinceValue }
      : provinceName === 'province_cnd'
      ? { province_cnd: provinceValue }
      : {})
    }
    data.accepts_marketing = true
    const url = newsletter_form_url;

      // Spinner
      $('.cfp_sub span').addClass('d-none')
      $('.cfp_sub .spinner').removeClass('d-none')

        // Pass the data to Boomi
       fetch(url, {
            method: 'post',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
          })
         .then(function (response) {
           if (response.ok) {
             // If form submitted will remove the spinner and close the form
             $('.cfp_sub span').removeClass('d-none')
             $('.cfp_sub .spinner').addClass('d-none')
             myForm.reset();
             $('#NewsletterFormAcceptsMarketingPhone').attr("value",'false');
             //$('#NewsletterFormAcceptsMarketing-popup').attr("value",'false');
             dataLayer.push({
              'event': 'newsletter_subscription'
             });
             let date = new Date();
             date.setFullYear(date.getFullYear() + 1); // ajoute 1 an
             document.cookie = "newsletter_subscribed=true; expires=" + date.toUTCString() + "; path=/";
           }

           // Examine the text in the response
           response.json().then(function (data) {
             $(".newsletter__text,.newsletter-form-inner, .required-fields-explanation").fadeOut(600,function(){
              $(".success-wrap").fadeIn();
             })
           });
         });

  }) 

  if( document.URL.endsWith("#nl-sign-up") ) {
    document.querySelector(".newsletter-popup-open-btn").click();
  }
  
  document.querySelector(".newsletter-popup-open-btn").addEventListener("click", function(e){
    e.preventDefault()
    if(!document.URL.endsWith("#nl-sign-up") ){
      window.history.replaceState(null,null,"#nl-sign-up")
    }
  })
  
})